// extracted by mini-css-extract-plugin
export default {"leaderboard_section":"Leaderboard_leaderboard_section__-Bhh5","heading":"Leaderboard_heading__IQIqG","para":"Leaderboard_para__OLnKY"};